// extracted by mini-css-extract-plugin
export var drawerPaper = "_1s-0";
export var itemCard = "_1s-1";
export var itemImage = "_1s-2";